import { Directive, Input, ElementRef, Renderer, Output, EventEmitter } from '@angular/core';
import { DomController } from 'ionic-angular';
import { Constants } from '../../constants';

/**
 * Generated class for the DirectivesAbsoluteDragDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[absolute-drag]' // Attribute selector
})
export class AbsoluteDragDirective {

  constructor(
    public element: ElementRef,
    public renderer: Renderer,
    public domCtrl: DomController
  ) {
  }

  @Input('x') x: any;
  @Input('y') y: any;
  @Output() newPositionDrag: EventEmitter<any> = new EventEmitter<any>();
  @Input('scroll') scroll: any;
  ngAfterViewInit() {

    this.renderer.setElementStyle(this.element.nativeElement, 'position', 'absolute');
    this.renderer.setElementStyle(this.element.nativeElement, 'left', this.x + 'px');
    this.renderer.setElementStyle(this.element.nativeElement, 'top', this.y + 'px');

    let hammer = new window['Hammer'](this.element.nativeElement);
    hammer.get('pan').set({ direction: window['Hammer'].DIRECTION_ALL, threshold: 0 });

    hammer.on('pan', (ev) => {
      this.handlePan(ev);
    });

  }

  handlePan(ev) {

    let horizontalCenter = this.element.nativeElement.width.baseVal.value;
    let verticalCenter = this.element.nativeElement.height.baseVal.value;

    console.log("getBoundingClientRect: ", this.element.nativeElement.getBoundingClientRect());

    let newLeft = ev.center.x - horizontalCenter;
    let newTop = ev.center.y - Constants.DRAG_OFFSET_Y - verticalCenter;
    // // let newLeft = ev.center.x;
    // // let newTop = ev.center.y - Constants.DRAG_OFFSET_Y;
    let scrollAux = this.scroll == undefined ? 0 : this.scroll
    let newTopAux = newTop +  scrollAux
    console.log("NEW TOP AUX", newTopAux, " SCROLL", this.scroll, " newTop ", newTop)
    this.domCtrl.write(() => { 
      this.renderer.setElementStyle(this.element.nativeElement, 'left', newLeft + 'px');
      this.renderer.setElementStyle(this.element.nativeElement, 'top', newTopAux + 'px');
    });

    this.newPositionDrag.emit({ x: ev.center.x, y: (ev.center.y - Constants.DRAG_OFFSET_Y) + scrollAux });

  }
  /* handlePan(ev){
     
     let newLeft = ev.center.x;
     let newTop = ev.center.y;
 
     this.domCtrl.write(() => {
         this.renderer.setElementStyle(this.element.nativeElement, 'left', newLeft + 'px');
         this.renderer.setElementStyle(this.element.nativeElement, 'top', newTop + 'px');
     });*/

  //}

}



// WEBPACK FOOTER //
// ./src/directives/absolute-drag/absolute-drag.ts